import { useState, useEffect } from 'react';

export default function NewsCard() {
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);
  const [minimized, setMinimized] = useState(false);

  useEffect(() => {
    const isDismissed = sessionStorage.getItem('news_card_dismissed');
    if (isDismissed) {
      setClosed(true);
      return;
    }
    const timer = setTimeout(() => setVisible(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => setClosed(true), 400);
    sessionStorage.setItem('news_card_dismissed', '1');
  };

  if (closed) return null;

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8 pointer-events-none'
      }`}
      style={{ maxWidth: '340px', width: '90vw' }}
    >
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden"
        style={{ boxShadow: '0 8px 40px rgba(0,0,0,0.13)' }}
      >
        {/* Header coloré */}
        <div className="relative bg-gradient-to-r from-teal-500 to-teal-600 px-5 py-4">
          {/* Badge animé */}
          <span className="inline-flex items-center gap-1.5 bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full mb-2">
            <span className="w-2 h-2 rounded-full bg-yellow-300 animate-pulse"></span>
            Actualité CasaReNovaPlus
          </span>
          <h3 className="text-white font-bold text-base leading-snug">
            Nous recrutons !
          </h3>
          {/* Boutons */}
          <div className="absolute top-3 right-3 flex gap-1">
            <button
              onClick={() => setMinimized(m => !m)}
              className="w-7 h-7 flex items-center justify-center rounded-full bg-white/15 hover:bg-white/30 text-white transition-all cursor-pointer"
              aria-label="Réduire"
            >
              <i className={`text-xs ${minimized ? 'ri-add-line' : 'ri-subtract-line'}`}></i>
            </button>
            <button
              onClick={handleClose}
              className="w-7 h-7 flex items-center justify-center rounded-full bg-white/15 hover:bg-white/30 text-white transition-all cursor-pointer"
              aria-label="Fermer"
            >
              <i className="ri-close-line text-xs"></i>
            </button>
          </div>
        </div>

        {/* Corps */}
        <div
          className={`transition-all duration-400 overflow-hidden ${
            minimized ? 'max-h-0' : 'max-h-96'
          }`}
        >
          <div className="px-5 py-4">
            {/* Icône + texte */}
            <div className="flex gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-teal-50 flex-shrink-0">
                <i className="ri-user-add-line text-teal-600 text-lg"></i>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed">
                CasaReNovaPlus est en pleine croissance et recherche des <strong className="text-gray-800">collaborateurs motivés</strong> pour rejoindre notre équipe à Neuenegg.
              </p>
            </div>

            {/* Postes */}
            <div className="space-y-2 mb-4">
              {[
                { icon: 'ri-flashlight-line', label: 'Électricien certifié' },
                { icon: 'ri-tools-line', label: 'Technicien maintenance' },
                { icon: 'ri-brush-line', label: 'Agent de nettoyage' },
              ].map((post, i) => (
                <div key={i} className="flex items-center gap-2.5 bg-gray-50 rounded-lg px-3 py-2">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${post.icon} text-teal-500 text-sm`}></i>
                  </div>
                  <span className="text-gray-700 text-sm font-medium">{post.label}</span>
                  <span className="ml-auto text-xs text-teal-600 font-semibold bg-teal-50 px-2 py-0.5 rounded-full">Ouvert</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <a
              href="/recrutement"
              onClick={handleClose}
              className="flex items-center justify-center gap-2 w-full bg-teal-500 hover:bg-teal-600 text-white text-sm font-semibold py-2.5 rounded-xl transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-send-plane-line"></i>
              Voir les offres d'emploi
            </a>
            <p className="text-center text-xs text-gray-400 mt-2">
              Réponse sous 48h garantie
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
